<section class="bg-half-170 d-table w-100" id="home"
         style="background: url('assets/3r/a71838f44b49156cac4a179aec1a006b.jpg') center center;">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-6">
                <div class="title-heading mt-4">
                    <h1 class="display-4 font-weight-bold text-white title-dark mb-3">About us</h1>
                    <p class="para-desc text-white-50"></p>
                    <div class="mt-4">
                        <a href="javascript:void(0)" class="btn btn-icon btn-pills btn-lg btn-light">
                            <i-feather name="arrow-down" class="icons"></i-feather>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<!--end section-->
<div class="position-relative">
    <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>
<!--end section-->
<!-- Hero End -->

<!-- Shape Start -->
<div class="position-relative">
    <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>
<!--Shape End-->

<!-- About Start -->
<section class="section">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
                <div class="position-relative">
                    <img src="assets/3r/1.PNG" class="rounded img-fluid mx-auto d-block" alt="">
                    <div class="play-icon">
                        <a (click)="openWindowCustomClass(content)" href="javascript:void(0);"
                           class="play-btn video-play-icon">
                            <i class="mdi mdi-play text-primary rounded-circle bg-white shadow"></i>
                        </a>
                        <ng-template #content let-modal>
                            <div class="modal-header">
                                <button type="button" class="close" aria-label="Close"
                                        (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <iframe width="780" height="450" src="https://www.youtube.com/embed/3L_g_vL2uCY"
                                        title="YouTube video player" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                            </div>
                        </ng-template>

                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-7 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
                <div class="section-title ml-lg-4">
                    <h4 class="title mb-4">Our Story</h4>
                    <p class="text-muted">
                        Growing from strength to strength, the 3R Travels team always looks to provide our valued
                        clients more than promised. The 3R team is reachable 24 hours 7 days a week.
                        <br>
                        Our team provides a variety of services for the incoming tourists.
                        The services provided are:
                    <li>Booking accommodation from Budget to Deluxe & Bungalow to Boutique hotels</li>
                    <li>Organizing pre-maid or tailor made sight seeing tours in Sri Lanka</li>
                    <li>Providing airport transfers and arranging transport for tours</li>
                    <li>Providing self drive vehicles</li>
                    <li>Helicopter transportation</li>
                    <li>Organizing Wedding ceremonies</li>
                    <li>Conference arrangements</li>
                    <li>Incentive programmes</li>
                    <li>Diving programmes in Sri Lanka for the beginner and experienced</li>
                    <li>Booking Maldives Resorts + flight tickets</li>
                    <li>Sri Lanka – Maldives combined programmes</li>
                    <li>Maldives Wedding arrangements</li>


                    We are proud and confident of our services because we have many, and many repeat clients from all
                    over the world who place their trust in us and book a variety of services many times. Also
                    introducing family and friends to 3R Travels shows the strength of the 3R team hospitality.

                    <br>
                    Call us or E-mail us. We will arrange all your holiday arrangements to suite your budget.
                    </p>

                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<!--end section-->
<!-- About End -->

<!-- Team Start -->
<section class="section bg-light">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <div class="section-title mb-4 pb-2">
                    <h4 class="title mb-4">Our Greatest Minds</h4>
                    <!--                    <p class="text-muted para-desc mx-auto mb-0">Start working with <span-->
                    <!--                            class="text-primary font-weight-bold">Landrick</span> that can provide everything you need-->
                    <!--                        to generate-->
                    <!--                        awareness, drive traffic, connect.</p>-->
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->

        <div class="row">
            <div class="col-lg-3 col-md-6 mt-4 pt-2">
                <div class="card team text-center bg-transparent border-0">
                    <div class="card-body p-0">
                        <div class="position-relative">
                            <img src="assets/3r/admin/emil.JPG"
                                 class="img-fluid avatar avatar-ex-large rounded-circle" alt="">
                            <!--                            <ul class="list-unstyled social-icon team-icon mb-0 mt-4">-->
                            <!--                                <li class="list-inline-item"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="facebook" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="instagram" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="twitter" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="linkedin" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                            </ul>-->
                            <!--end icon-->
                        </div>
                        <div class="content pt-3 pb-3">
                            <h5 class="mb-0"><a href="javascript:void(0)" class="name text-dark">Mr.Emil
                                Fernandopulle</a></h5>
                            <small class="designation text-muted"> Founder CEO</small>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <!--            <div class="col-lg-3 col-md-6 mt-4 pt-2">-->
            <!--                <div class="card team text-center bg-transparent border-0">-->
            <!--                    <div class="card-body p-0">-->
            <!--                        <div class="position-relative">-->
            <!--                            <img src="assets/3r/admin/user-3331257__340%20(1).png"-->
            <!--                                 class="img-fluid avatar avatar-ex-large rounded-circle" alt="">-->
            <!--&lt;!&ndash;                            <ul class="list-unstyled social-icon team-icon mb-0 mt-4">&ndash;&gt;-->
            <!--&lt;!&ndash;                                <li class="list-inline-item"><a href="javascript:void(0)" class="rounded">&ndash;&gt;-->
            <!--&lt;!&ndash;                                    <i-feather name="facebook" class="fea icon-sm fea-social"></i-feather>&ndash;&gt;-->
            <!--&lt;!&ndash;                                </a></li>&ndash;&gt;-->
            <!--&lt;!&ndash;                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">&ndash;&gt;-->
            <!--&lt;!&ndash;                                    <i-feather name="instagram" class="fea icon-sm fea-social"></i-feather>&ndash;&gt;-->
            <!--&lt;!&ndash;                                </a></li>&ndash;&gt;-->
            <!--&lt;!&ndash;                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">&ndash;&gt;-->
            <!--&lt;!&ndash;                                    <i-feather name="twitter" class="fea icon-sm fea-social"></i-feather>&ndash;&gt;-->
            <!--&lt;!&ndash;                                </a></li>&ndash;&gt;-->
            <!--&lt;!&ndash;                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">&ndash;&gt;-->
            <!--&lt;!&ndash;                                    <i-feather name="linkedin" class="fea icon-sm fea-social"></i-feather>&ndash;&gt;-->
            <!--&lt;!&ndash;                                </a></li>&ndash;&gt;-->
            <!--&lt;!&ndash;                            </ul>&ndash;&gt;-->
            <!--                            &lt;!&ndash;end icon&ndash;&gt;-->
            <!--                        </div>-->
            <!--                        <div class="content pt-3 pb-3">-->
            <!--                            <h5 class="mb-0"><a href="javascript:void(0)" class="name text-dark">Miss. Daisy Victor</a>-->
            <!--                            </h5>-->
            <!--                            <small class="designation text-muted"> Director </small>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--end col-->

            <div class="col-lg-3 col-md-6 mt-4 pt-2">
                <div class="card team text-center bg-transparent border-0">
                    <div class="card-body p-0">
                        <div class="position-relative">
                            <img src="assets/3r/admin/rakitha.jpeg"
                                 class="img-fluid avatar avatar-ex-large rounded-circle" alt="">
                            <!--                            <ul class="list-unstyled social-icon team-icon mb-0 mt-4">-->
                            <!--                                <li class="list-inline-item"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="facebook" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="instagram" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="twitter" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="linkedin" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                            </ul>-->
                            <!--end icon-->
                        </div>
                        <div class="content pt-3 pb-3">
                            <h5 class="mb-0"><a href="javascript:void(0)" class="name text-dark">Mr. Rakitha
                                Abeykoon</a></h5>
                            <small class="designation text-muted">Director Marketing</small>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-3 col-md-6 mt-4 pt-2">
                <div class="card team text-center bg-transparent border-0">
                    <div class="card-body p-0">
                        <div class="position-relative">
                            <img src="assets/3r/admin/WhatsApp%20Image%202021-10-27%20at%2010.57.45%20AM.jpeg"
                                 class="img-fluid avatar avatar-ex-large rounded-circle" alt="">
                            <!--                            <ul class="list-unstyled social-icon team-icon mb-0 mt-4">-->
                            <!--                                <li class="list-inline-item"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="facebook" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="instagram" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="twitter" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="linkedin" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                            </ul>-->
                            <!--end icon-->
                        </div>
                        <div class="content pt-3 pb-3">
                            <h5 class="mb-0"><a href="javascript:void(0)" class="name text-dark">Mr. Bjorn Lewerenz</a></h5>
                            <small class="designation text-muted">Director - International Travel</small>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-3 col-md-6 mt-4 pt-2">
                <div class="card team text-center bg-transparent border-0">
                    <div class="card-body p-0">
                        <div class="position-relative">
                            <img src="assets/3r/admin/SONALI%20fernando.jpeg"
                                 class="img-fluid avatar avatar-ex-large rounded-circle" alt="">
                            <!--                            <ul class="list-unstyled social-icon team-icon mb-0 mt-4">-->
                            <!--                                <li class="list-inline-item"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="facebook" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="instagram" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="twitter" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                                <li class="list-inline-item ml-1"><a href="javascript:void(0)" class="rounded">-->
                            <!--                                    <i-feather name="linkedin" class="fea icon-sm fea-social"></i-feather>-->
                            <!--                                </a></li>-->
                            <!--                            </ul>-->
                            <!--end icon-->
                        </div>
                        <div class="content pt-3 pb-3">
                            <h5 class="mb-0"><a href="javascript:void(0)" class="name text-dark">Miss. Sonali
                                Fernando</a></h5>
                            <small class="designation text-muted">Ticketing Assistant</small>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->

    <!--  <div class="container mt-100 mt-60">-->
    <!--    <div class="row justify-content-center">-->
    <!--      <div class="col-12 text-center">-->
    <!--        <div class="section-title">-->
    <!--          <h4 class="title mb-4">See everything about your employee at one place.</h4>-->
    <!--          <p class="text-muted para-desc mx-auto">Start working with <span-->
    <!--              class="text-primary font-weight-bold">Landrick</span> that can provide everything you need to generate-->
    <!--            awareness, drive traffic, connect.</p>-->

    <!--          <div class="mt-4">-->
    <!--            <a href="javascript:void(0)" class="btn btn-primary mt-2 mr-2">Get Started Now</a>-->
    <!--            <a href="javascript:void(0)" class="btn btn-outline-primary mt-2">Free Trial</a>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      &lt;!&ndash;end col&ndash;&gt;-->
    <!--    </div>-->
    <!--end row-->
    <!--  </div>-->
    <!--end container-->
</section>
<!--end section-->
<!-- Team End -->


<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-soft-primary back-to-top" id="back-to-top"
   [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->
